import { Helmet } from "react-helmet-async";

const SITE = "https://bihanichildrensacademy.com";

export default function SEO({ title, description, path = "/", noindex = false }) {
  const url = SITE + path;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex
        ? <meta name="robots" content="noindex" />
        : <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}